const KEYFRAMES_STYLE_ID = 'planne-confetti-keyframes';

export const DEFAULT_CONFETTI_ANIMATION_NAME = 'planneConfettiBurst';

export const ensureConfettiKeyframes = (animationName = DEFAULT_CONFETTI_ANIMATION_NAME): void => {
  if (typeof document === 'undefined') {
    return;
  }

  const existing = document.getElementById(KEYFRAMES_STYLE_ID);
  if (existing?.dataset['animationName'] === animationName) {
    return;
  }

  existing?.remove();

  const style = document.createElement('style');
  style.id = KEYFRAMES_STYLE_ID;
  style.dataset['animationName'] = animationName;
  style.textContent = `
    @keyframes ${animationName} {
      0% { transform: translate(0, 0) rotate(0deg); opacity: 1; }
      75% { opacity: 1; }
      100% { transform: translate(var(--tx), var(--ty)) rotate(var(--rot)); opacity: 0; }
    }
  `;
  document.head.appendChild(style);
};
